import { StyleParamType, wixColorParam, wixFontParam, createStylesParams } from '@wix/tpa-settings';
import {
  FormStylesParams,
  reviewFormStylesParams,
} from '~commons/components/review-form/Settings/stylesParams';

export type AllStylesParams = {
  productPreviewTitleFont: StyleParamType.Font;
  productPreviewTitleColor: StyleParamType.Color;
  productPreviewTitleFontSize: StyleParamType.Number;
} & FormStylesParams;

const styleParams = createStylesParams<AllStylesParams>({
  productPreviewTitleFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-L', { size: 16 }),
  },
  productPreviewTitleColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
  },
  ...reviewFormStylesParams,
  //   Mobile
  productPreviewTitleFontSize: {
    type: StyleParamType.Number,
    getDefaultValue: (props) => {
      const titleFont = props.getStyleParamValue(styleParams.productPreviewTitleFont, {
        isMobile: props.isMobile,
        isRTL: props.isRTL,
      });
      return titleFont.size;
    },
  },
});

export type StylesParams = typeof styleParams;

export default styleParams;
